/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/axios.js'
Vue.prototype.$http = axios

const actions = {

  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth ({ commit }, width) {
    commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
  },

  // VxAutoSuggest
  updateStarredPage ({ commit }, payload) {
    commit('UPDATE_STARRED_PAGE', payload)
  },

  // The Navbar
  arrangeStarredPagesLimited ({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_LIMITED', list)
  },
  arrangeStarredPagesMore ({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_MORE', list)
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay ({ commit }) {
    commit('TOGGLE_CONTENT_OVERLAY')
  },
  updateTheme ({ commit }, val) {
    commit('UPDATE_THEME', val)
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  updateUserInfo ({ commit }, payload) {
    commit('UPDATE_USER_INFO', payload)
  },
   
  updateUserRole ({ dispatch }, payload) {
    // Change client side
    //console.log(payload.userRole)
    payload.aclChangeRole(payload.userRole)
  
    // Make API call to server for changing role
  
    // Change userInfo in localStorage and store
    dispatch('updateUserInfo', {userRole: payload.userRole})
  },
    
  login ({commit}, user) {
    return new Promise((resolve, reject) => {
      commit('auth_request')
      const payload = JSON.stringify(user)
      Vue.prototype.$http.post('/login/', payload)
      //axios({url: '/login/', data: payload, method: 'POST' })
        .then((response) => {
          if (response.data.messageType == 'success') {
            const token = response.data.token_information.access_token
            const user_details = {'user_info': response.data.userinfo, 'user_permissions':response.data.user_permissions}
            localStorage.setItem('token', token)
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
            commit('auth_success', token)
            commit('UPDATE_USER_INFO', user_details)
          } else {
            console.log(response.data.message)
            commit('auth_error')
            localStorage.removeItem('token')
            localStorage.removeItem('userInfo')
          }
          resolve(response)
        })
        .catch((error)   => {
          commit('auth_error')
          console.log(error)
          localStorage.removeItem('token')
          localStorage.removeItem('userInfo')
          reject(error)
        })
    })
  },

  logout ({commit}) {
    return new Promise((resolve, reject) => {
      commit('logout')
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      delete axios.defaults.headers.common['Authorization']
      resolve()
    })
  }
}

export default actions
